import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "card mb-10"
}
const _hoisted_4 = { class: "card-header border-0 pt-10" }
const _hoisted_5 = { class: "card-title align-items-start flex-column" }
const _hoisted_6 = { class: "card-label fw-bolder fs-3 mb-3" }
const _hoisted_7 = { class: "mt-1 fw-bold fs-7" }
const _hoisted_8 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_9 = { class: "card-title align-items-start flex-column" }
const _hoisted_10 = { class: "card-label fw-bolder fs-3 mb-3" }
const _hoisted_11 = { class: "align-self-start d-flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf fs-2 me-3" }, null, -1)
const _hoisted_13 = ["download", "href"]
const _hoisted_14 = { class: "align-self-end justify-content-center pb-3 me-10" }
const _hoisted_15 = { class: "card mb-5 mb-xl-10" }
const _hoisted_16 = { class: "card-header border-0" }
const _hoisted_17 = { class: "card-title m-0" }
const _hoisted_18 = { class: "fw-bolder m-0" }
const _hoisted_19 = { class: "card-title m-0" }
const _hoisted_20 = { class: "collapse show" }
const _hoisted_21 = { class: "card-body border-top p-9" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "col-lg-8 fv-row" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "row mb-6" }
const _hoisted_43 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_58 = { class: "pb-5" }
const _hoisted_59 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "row mb-6" }
const _hoisted_67 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "col-lg-8 fv-row" }
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "row mb-6" }
const _hoisted_72 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "col-lg-8 fv-row" }
const _hoisted_74 = { class: "row mb-6" }
const _hoisted_75 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_76 = { class: "col-lg-8 fv-row" }
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_80 = { class: "pb-5" }
const _hoisted_81 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_82 = { class: "row mb-6" }
const _hoisted_83 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_84 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_85 = { class: "fv-plugins-message-container" }
const _hoisted_86 = { class: "fv-help-block" }
const _hoisted_87 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8 fv-row" }
const _hoisted_90 = { class: "fv-plugins-message-container" }
const _hoisted_91 = { class: "fv-help-block" }
const _hoisted_92 = { class: "row mb-6" }
const _hoisted_93 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_94 = { class: "col-lg-8 fv-row" }
const _hoisted_95 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_96 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_97 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_102 = { class: "card mb-5 mb-xl-10" }
const _hoisted_103 = { class: "card-header border-0" }
const _hoisted_104 = { class: "card-title m-0" }
const _hoisted_105 = { class: "fw-bolder m-0" }
const _hoisted_106 = { class: "collapse show" }
const _hoisted_107 = { class: "card-body border-top p-9" }
const _hoisted_108 = { class: "row mb-6" }
const _hoisted_109 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_110 = { class: "col-lg-8 fv-row" }
const _hoisted_111 = { class: "row mb-6" }
const _hoisted_112 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_113 = { class: "col-lg-8 fv-row" }
const _hoisted_114 = { class: "row mb-6" }
const _hoisted_115 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_116 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_117 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_118 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_119 = { class: "col-lg-8 fv-row" }
const _hoisted_120 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_121 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_122 = { class: "col-lg-8 fv-row" }
const _hoisted_123 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_124 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_125 = { class: "col-lg-8 fv-row" }
const _hoisted_126 = { class: "fv-plugins-message-container" }
const _hoisted_127 = { class: "fv-help-block" }
const _hoisted_128 = { class: "row mb-6" }
const _hoisted_129 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_130 = { class: "col-lg-8 fv-row" }
const _hoisted_131 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_132 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_133 = { class: "col-lg-8 fv-row" }
const _hoisted_134 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_135 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_136 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_137 = { class: "col-lg-3 fv-row fv-plugins-icon-container" }
const _hoisted_138 = ["onClick"]
const _hoisted_139 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_140 = [
  _hoisted_139
]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_142 = { class: "row mb-6" }
const _hoisted_143 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_144 = { class: "col-lg-8 fv-row" }
const _hoisted_145 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_146 = { class: "col-lg-10 fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_147 = ["download", "href"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_149 = { class: "d-inline-block align-middle my-2 ms-1" }
const _hoisted_150 = {
  key: 0,
  class: "align-middle"
}
const _hoisted_151 = ["onClick"]
const _hoisted_152 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = {
  key: 1,
  class: "align-middle"
}
const _hoisted_155 = ["onClick"]
const _hoisted_156 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_157 = [
  _hoisted_156
]
const _hoisted_158 = { class: "row mb-6" }
const _hoisted_159 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_160 = { class: "col-lg-8 fv-row" }
const _hoisted_161 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_documentos"
}
const _hoisted_162 = { class: "dz-message needsclick" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_164 = { class: "ms-4" }
const _hoisted_165 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_166 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_167 = { class: "card mb-5 mb-xl-10" }
const _hoisted_168 = { class: "card-header border-0" }
const _hoisted_169 = { class: "card-title m-0" }
const _hoisted_170 = { class: "fw-bolder m-0" }
const _hoisted_171 = { class: "collapse show" }
const _hoisted_172 = { class: "card-body border-top p-9" }
const _hoisted_173 = { class: "row mb-6" }
const _hoisted_174 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_175 = { class: "col-lg-8 fv-row" }
const _hoisted_176 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_177 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_178 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_179 = ["onClick"]
const _hoisted_180 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_181 = [
  _hoisted_180
]
const _hoisted_182 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_183 = { class: "row" }
const _hoisted_184 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_185 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_186 = { class: "row" }
const _hoisted_187 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_188 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_189 = { class: "row" }
const _hoisted_190 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_191 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_192 = { class: "row" }
const _hoisted_193 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_194 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_195 = { class: "row mb-6" }
const _hoisted_196 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_197 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_198 = { class: "row mb-6" }
const _hoisted_199 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_200 = { class: "col-lg-8 fv-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ServiciosTabla = _resolveComponent("ServiciosTabla")!
  const _component_ServiciosColectivosTabla = _resolveComponent("ServiciosColectivosTabla")!
  const _component_Historico = _resolveComponent("Historico")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _component_SendEmailModal = _resolveComponent("SendEmailModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_dropdown, { class: "mx-3" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_send_email",
                  onClick: _ctx.prepareSendEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.enviarCorreo")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_divider, { class: "my-2" }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _ctx.eliminar,
                  disabled: _ctx.servicios.length || _ctx.serviciosColectivos.length
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit,
          loading: _ctx.guardaDetalle,
          disabled: _ctx.isReading
        }, {
          default: _withCtx(() => [
            (!_ctx.isReading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.guardar.button")), 1))
              : (_ctx.isReading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.cargandoArchivos")), 1))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ]),
      default: _withCtx(() => [
        (_ctx.seSolicitaActualizacion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h3", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("profesional.actualizacion.titulo")), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.datosProfesionalActualizar?.datosSolicitud?.detalleActualizacion), 1)
                ])
              ]),
              (_ctx.datosProfesionalActualizar?.datosAdjuntos?.datosAdjuntos?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("profesional.actualizacion.adjuntos")), 1),
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosProfesionalActualizar?.datosAdjuntos
                ?.datosAdjuntos, (archivo) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "mt-1 fw-bold fs-7 d-flex me-5",
                            key: archivo.nombre
                          }, [
                            _hoisted_12,
                            _createElementVNode("a", {
                              class: "el-upload-list__item-name",
                              download: archivo.nombre,
                              href: archivo.data
                            }, _toDisplayString(archivo.nombre), 9, _hoisted_13)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-color-secondary btn-active-light-primary text-uppercase",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.rechazarActualizacion && _ctx.rechazarActualizacion(...args)))
                }, _toDisplayString(_ctx.$t("profesional.actualizacion.rechazar")), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-color-primary btn-active-light-primary text-uppercase",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.aceptarActualizacion && _ctx.aceptarActualizacion(...args)))
                }, _toDisplayString(_ctx.$t("profesional.actualizacion.aceptar")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.profesionalDetalle.listadoGroup')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.listadoGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.claseEstado)
                      }, _toDisplayString(_ctx.estado), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_el_select, {
                            name: "tratamiento",
                            class: "w-100",
                            modelValue: _ctx.tratamiento,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tratamiento) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tratamiento.text,
                                  value: tratamiento.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nombre.label")), 1),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "nombre",
                                placeholder: " ",
                                modelValue: _ctx.nombre,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nombre) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_ErrorMessage, { name: "nombre" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "apellidos",
                                placeholder: " ",
                                modelValue: _ctx.apellidos,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.apellidos) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createVNode(_component_ErrorMessage, { name: "apellidos" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.dni.label")), 1),
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "dni",
                            placeholder: " ",
                            modelValue: _ctx.dni,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dni) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_ErrorMessage, { name: "dni" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.email.label")), 1),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "email",
                            placeholder: " ",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_ErrorMessage, { name: "email" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.telefono.label")), 1),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "telefono",
                            placeholder: " ",
                            modelValue: _ctx.telefono,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.telefono) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_51
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_ErrorMessage, { name: "telefono" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.fechaNacimiento.label")), 1),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_el_date_picker, {
                            format: "DD/MM/YYYY",
                            modelValue: _ctx.fechaNacimiento,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                            type: "date",
                            "disabled-date": _ctx.disabledDate,
                            class: "w-100"
                          }, null, 8, ["modelValue", "disabled-date"])
                        ])
                      ]),
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("h4", _hoisted_59, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccionGroup")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "direccion",
                            placeholder: " ",
                            modelValue: _ctx.direccion,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.direccion) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_63
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_ErrorMessage, { name: "direccion" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.localidad.label")), 1),
                        _createElementVNode("div", _hoisted_68, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "localidad",
                            placeholder: " ",
                            modelValue: _ctx.localidad,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localidad) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _createVNode(_component_ErrorMessage, { name: "localidad" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.comarca.label")), 1),
                        _createElementVNode("div", _hoisted_73, [
                          _createVNode(_component_el_select, {
                            disabled: !_ctx.isAdmin,
                            modelValue: _ctx.comarcaId,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.comarcaId) = $event)),
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcasResidencia, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.text,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.provincia.label")), 1),
                        _createElementVNode("div", _hoisted_76, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "provincia",
                            placeholder: " ",
                            modelValue: _ctx.provincia,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.provincia) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _createVNode(_component_ErrorMessage, { name: "provincia" })
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("h4", _hoisted_81, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.otrosDatos")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.carnetConducir.label")), 1),
                        _createElementVNode("div", _hoisted_84, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.carnetConducir,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.carnetConducir) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_component_ErrorMessage, { name: "carnetConducir" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.carnetConducir)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.vehiculoPropio.label")), 1),
                            _createElementVNode("div", _hoisted_89, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.vehiculo,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.vehiculo) = $event)),
                                class: "w-100",
                                placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.vehiculoPropio.label')
                    
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiculos, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.nombre,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"]),
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createVNode(_component_ErrorMessage, { name: "vehiculo" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.idiomas.label")), 1),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("ul", _hoisted_95, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idiomas, (idioma, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "row"
                              }, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createVNode(_component_el_select, {
                                    modelValue: idioma.nombreIdioma,
                                    "onUpdate:modelValue": ($event: any) => ((idioma.nombreIdioma) = $event),
                                    class: "w-100",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.idiomas.nombre')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nombreIdioma, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                  _createVNode(_component_el_select, {
                                    modelValue: idioma.nivel,
                                    "onUpdate:modelValue": ($event: any) => ((idioma.nivel) = $event),
                                    class: "w-100",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.idiomas.nivel')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nivel, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeIdioma(i))
                                }, _hoisted_100, 8, _hoisted_98)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addIdioma && _ctx.addIdioma(...args)))
                          }, [
                            _hoisted_101,
                            _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.idiomas.nuevoIdioma")), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.profesionalDetalle.datosProfesionalGroup')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("h3", _hoisted_105, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.datosProfesionalGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.ubicacionTrabajo.label")), 1),
                        _createElementVNode("div", _hoisted_110, [
                          _createVNode(_component_el_select, {
                            name: "comarcasTrabajoIds",
                            modelValue: _ctx.comarcasTrabajoIds,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.comarcasTrabajoIds) = $event)),
                            multiple: "",
                            class: "w-100",
                            placeholder: 
                      _ctx.$t(
                        'formularios.profesionalDetalle.ubicacionTrabajo.label'
                      )
                    
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.nombreCompuesto,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.ubicacionesSolicitaTrabajo.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_113, [
                          _createVNode(_component_el_select, {
                            name: "comarcasSolicitaTrabajoIds",
                            modelValue: _ctx.comarcasSolicitaTrabajoIds,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.comarcasSolicitaTrabajoIds) = $event)),
                            disabled: "",
                            multiple: "",
                            class: "w-100",
                            placeholder: 
                      _ctx.$t(
                        'formularios.profesionalDetalle.ubicacionesSolicitaTrabajo.label'
                      )
                    
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.nombreCompuesto,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponeTitulacion.label")), 1),
                        _createElementVNode("div", _hoisted_116, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.disponeTitulacion,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.disponeTitulacion) = $event)),
                            onChange: _ctx.changeDisponeTitulacion,
                            "active-color": ""
                          }, null, 8, ["modelValue", "onChange"])
                        ])
                      ]),
                      (_ctx.disponeTitulacion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                            _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacion.label")), 1),
                            _createElementVNode("div", _hoisted_119, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.titulacion,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.titulacion) = $event)),
                                multiple: "",
                                class: "w-100",
                                placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulaciones.label')
                    
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titulaciones, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.text,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.disponeTitulacion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacionOtras.label")), 1),
                            _createElementVNode("div", _hoisted_122, [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.titulacion,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.titulacion) = $event)),
                                multiple: "",
                                class: "w-100",
                                placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulaciones.label')
                    
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sinTitulaciones, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.text,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showOtrasTitulaciones)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                            _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.detalleTitulacionOtras.label"
                    )), 1),
                            _createElementVNode("div", _hoisted_125, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "titulacionOtras",
                                placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulacionOtras.label')
                    ,
                                modelValue: _ctx.titulacionOtras,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.titulacionOtras) = $event))
                              }, null, 8, ["placeholder", "modelValue"]),
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createVNode(_component_ErrorMessage, { name: "titulacionOtras" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.experienciaCuidadoMenores.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_130, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.experienciaCuidadoMenores,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.experienciaCuidadoMenores) = $event)),
                            class: "w-100",
                            placeholder: 
                      _ctx.$t(
                        'formularios.profesionalDetalle.experienciaCuidadoMenores.label'
                      )
                    
                          }, {
                            default: _withCtx(() => [
                              (_ctx.disponeTitulacion)
                                ? (_openBlock(), _createBlock(_component_el_option, {
                                    key: 0,
                                    value: "EXPERIENCIAPROFESIONAL",
                                    label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIAPROFESIONAL')
                      
                                  }, null, 8, ["label"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_option, {
                                value: "EXPERIENCIANOPROFESIONAL",
                                label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIANOPROFESIONAL')
                      
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_option, {
                                value: "SINEXPERIENCIA",
                                label: _ctx.$t('experienciaCuidadoMenores.SINEXPERIENCIA')
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      (
                  _ctx.experienciaCuidadoMenores != 'SINEXPERIENCIA' &&
                  _ctx.experienciaCuidadoMenores != ''
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                            _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.experiencia.label")), 1),
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("ul", _hoisted_134, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experiencia, (ele, i) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: i,
                                    class: "row"
                                  }, [
                                    _createElementVNode("div", _hoisted_135, [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.tipo.label'
                            )
                          ,
                                        modelValue: ele.tipo,
                                        "onUpdate:modelValue": ($event: any) => ((ele.tipo) = $event)
                                      }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_136, [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.dirigidoA.label'
                            )
                          ,
                                        modelValue: ele.dirigidoA,
                                        "onUpdate:modelValue": ($event: any) => ((ele.dirigidoA) = $event)
                                      }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_137, [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.duracion.label'
                            )
                          ,
                                        modelValue: ele.duracion,
                                        "onUpdate:modelValue": ($event: any) => ((ele.duracion) = $event)
                                      }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                      onClick: ($event: any) => (_ctx.removeExperiencia(i))
                                    }, _hoisted_140, 8, _hoisted_138)
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addExperiencia && _ctx.addExperiencia(...args)))
                              }, [
                                _hoisted_141,
                                _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.profesionalDetalle.experiencia.nuevaExperiencia"
                      )), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.documentos.label")), 1),
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("ul", _hoisted_145, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "el-upload-list__item is-success",
                                tabindex: "0"
                              }, [
                                _createElementVNode("div", _hoisted_146, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: `${_ctx.nombre}${_ctx.apellidos}${file.tipo}-${file.nombre}`,
                                    href: file.blob
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.blob,
                                      fit: "cover"
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_148
                                      ]),
                                      _: 2
                                    }, 1032, ["src"])
                                  ], 8, _hoisted_147),
                                  _createElementVNode("div", _hoisted_149, [
                                    (_ctx.editingIndex !== i)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_150, [
                                          _createTextVNode(_toDisplayString(file.nombre) + " ", 1),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-link p-0 ms-2",
                                            onClick: ($event: any) => (_ctx.startEditNombre(i)),
                                            title: "Editar nombre"
                                          }, _hoisted_153, 8, _hoisted_151)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_154, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.editingNombre,
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editingNombre) = $event)),
                                            size: "small",
                                            class: "d-inline-block",
                                            onBlur: ($event: any) => (_ctx.commitEditNombre(i, file.id)),
                                            onKeyup: _withKeys(($event: any) => (_ctx.commitEditNombre(i, file.id)), ["enter"])
                                          }, null, 8, ["modelValue", "onBlur", "onKeyup"])
                                        ]))
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 d-inline-block btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeDocumento(i))
                                }, _hoisted_157, 8, _hoisted_155)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("label", _hoisted_159, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nuevosDocumentos.label")), 1),
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("div", _hoisted_161, [
                            _createElementVNode("div", _hoisted_162, [
                              _hoisted_163,
                              _createElementVNode("div", _hoisted_164, [
                                _createElementVNode("h3", _hoisted_165, _toDisplayString(_ctx.$t(
                              "formularios.profesionalDetalle.nuevosDocumentos.accion"
                            )), 1),
                                _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.$t(
                            "formularios.profesionalDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                              ])
                            ])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "certificadoAntecedentes",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.profesionalDetalle.disponibilidadGroup')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("h3", _hoisted_170, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponibilidadGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.disponibilidad.diasyhoras"
                    )), 1),
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("ul", _hoisted_176, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disponibilidadesArray, (tiempo, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "row"
                              }, [
                                _createElementVNode("div", _hoisted_177, [
                                  _createVNode(_component_el_select, {
                                    modelValue: tiempo.dias,
                                    "onUpdate:modelValue": ($event: any) => ((tiempo.dias) = $event),
                                    class: "w-100",
                                    multiple: "",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.dias.label')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dias, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("div", _hoisted_178, [
                                  _createVNode(_component_el_select, {
                                    modelValue: tiempo.horas,
                                    "onUpdate:modelValue": ($event: any) => ((tiempo.horas) = $event),
                                    class: "w-100",
                                    multiple: "",
                                    placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.horarios.label')
                          
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarios, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.text,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeHorario(i))
                                }, _hoisted_181, 8, _hoisted_179)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.addHorario && _ctx.addHorario(...args)))
                          }, [
                            _hoisted_182,
                            _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.profesionalDetalle.disponibilidad.nuevaDisponibilidad"
                      )), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_183, [
                        _createElementVNode("label", _hoisted_184, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.laborables.label")), 1),
                        _createElementVNode("div", _hoisted_185, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.laborables,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.laborables) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_186, [
                        _createElementVNode("label", _hoisted_187, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.finesDeSemana.label")), 1),
                        _createElementVNode("div", _hoisted_188, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.finesDeSemana,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.finesDeSemana) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.festivos.label")), 1),
                        _createElementVNode("div", _hoisted_191, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.festivos,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.festivos) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_192, [
                        _createElementVNode("label", _hoisted_193, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.urgencias.label")), 1),
                        _createElementVNode("div", _hoisted_194, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.urgencias,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.urgencias) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_195, [
                        _createElementVNode("label", _hoisted_196, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.noches.label")), 1),
                        _createElementVNode("div", _hoisted_197, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.noches,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.noches) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_198, [
                        _createElementVNode("label", _hoisted_199, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.detalleDisponibilidad.label"
                    )), 1),
                        _createElementVNode("div", _hoisted_200, [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.detalleDisponibilidad,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.detalleDisponibilidad) = $event)),
                            rows: 3,
                            autosize: { minRows: 2 },
                            type: "textarea",
                            placeholder: " "
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.servicios.length)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: _ctx.$t('formularios.profesionalDetalle.servicios'),
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ServiciosTabla, { servicios: _ctx.servicios }, null, 8, ["servicios"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.serviciosColectivos.length)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 1,
                  label: _ctx.$t('formularios.familiaDetalle.serviciosColectivos'),
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ServiciosColectivosTabla, { servicios: _ctx.serviciosColectivos }, null, 8, ["servicios"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.profesionalDetalle.historico.tab'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Historico)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_SendEmailModal, {
      context: _ctx.sendEmailContext,
      onSendEmail: _ctx.onSendEmail
    }, null, 8, ["context", "onSendEmail"])
  ], 64))
}